import { KeyRound, Plus } from "lucide-react";
import type { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

type ApiKeysEmptyStateProps =
  | { variant: "initial"; onAction: MouseEventHandler<HTMLButtonElement> }
  | { variant: "filtered"; onAction: MouseEventHandler<HTMLButtonElement> };

const ApiKeysEmptyState = ({ variant, onAction }: ApiKeysEmptyStateProps) => {
  const { t } = useTranslation();
  const isInitial = variant === "initial";

  return (
    <div
      className="flex min-h-[460px] flex-col items-center justify-center px-4 text-center"
      data-testid={`api-keys-${variant}-empty-state`}
    >
      <div className="mb-4 flex size-9 items-center justify-center rounded-lg bg-muted text-foreground">
        <KeyRound aria-hidden="true" className="size-4" />
      </div>
      <h2 className="text-sm font-medium text-foreground">
        {isInitial
          ? t("apiKeys.createFirstKey")
          : t("apiKeys.noDataFound")}
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        {isInitial
          ? t("apiKeys.createFirstKeyDescription")
          : t("apiKeys.noResultsDescription")}
      </p>
      <Button
        type="button"
        variant={isInitial ? "default" : "outline"}
        className="mt-4 h-9 rounded-lg px-4"
        onClick={onAction}
      >
        {isInitial ? <Plus aria-hidden="true" className="size-4" /> : null}
        {isInitial ? t("apiKeys.createNewKey") : t("apiKeys.clearFilters")}
      </Button>
    </div>
  );
};

export default ApiKeysEmptyState;
